import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-move-to-application',
  imports: [SharedModule],
  templateUrl: './move-to-application.component.html',
  styleUrl: './move-to-application.component.scss'
})
export class MoveToApplicationComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleMove() {

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: [this.editLeadData?.lead_id],
      reg_id: [this.editLeadData?.registration?.reg_id],
      current_stage: 'application',
      reg_data: {},
      old_lead_data: {},
      user_id: this.localStorage.getUserId(),
      application_date : new Date().toISOString(),
      is_student_profiles: [this.editLeadData?.is_student_profile ? 1 : 0]
    }

    this.isLoading = true;

    this.api.updateBulkLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
      }
    }
    );

  }


}
